import { Routes, Navigate, Route } from 'react-router';
import { NotFound, UserNotFound } from '@modules/notFound';

import { PageComponentProps } from '@core/Page';

import { RouteContainer } from '@core/Router/RouteContainer';
import { locations } from '@core/Router/locations';

import { userLocations } from '@user/routes/UserRouter';
import { patientLocations } from '@patient/routes/PatientRouter';
import { serviceLocations } from '@services/routes/ServiceRouter';
import { templateLocations } from '@template/routes/TemplateRouter';
import { organizationLocations } from '@organization/routes/OrganizationRouter';
import { scheduleLocations } from '@schedule/routes/ScheduleRouter';
import { priceLocations } from '@price/routes/PriceRouter';
import { planLocations } from '@plan/routes/PlanRouter';
import { notificationLocations } from '@notifications/routes/NotificationRouter';
import { labLocations } from '@lab/routes/LabRouter';
import { dashboardLocations } from '@dashboard/routes/DashboardRouter';
import { profileLocations } from '@profile/routes/ProfileRouter';
import { billingLocations } from '@billing/routes/BillingRouter';
import { uiLabLocations } from '@modules/uilab/UILabRouter';
import { configurationLocations } from '@configuration/routes/ConfigurationRouter';
import { attachmentLocations } from '@modules/attachment/routes/AttachmentRouter';
import { financeLocations } from '@finance/routes/FinanceRouter';
import { protestLocations } from '@insurance/routes/ProtestRouter';
import { promptsLocations } from '@modules/prompts/routes/PromptsRouter';
import { clinicsLocations } from '@modules/clinics/routes/ClinicsRouter';
import { drugDemoLocations } from '@modules/drugDemo/routes/DrugDemoRouter';
import { walkInLocations } from '@modules/walkIn/routes/WalkInRouter';
import { dataIsolationLocations } from '@modules/dataIsolation/routes/DataIsolationRouter';
import { USER_NOT_FOUND_ROUTE } from '@modules/notFound/routes/userNotFoundRoute';
import React, { lazy } from 'react';
import { ErrorBoundary } from '@core/Router/ErrorBoundary';

const BillingMachineApp = lazy(() =>
    import(/* webpackChunkName: "billing-machine" */ '@billing-machine/BillingMachineApp').then(m => ({
        default: m.BillingMachineApp,
    })),
);

export interface PageRouterProps extends PageComponentProps {}

export function PageRouter(_: PageRouterProps) {
    return (
        <ErrorBoundary>
            <Routes>
                <Route
                    path={'/'}
                    element={
                        <Navigate
                            to="/dashboard?currentPage=timeLine"
                            replace
                        />
                    }
                />
                {[
                    ...locations,
                    ...patientLocations,
                    ...userLocations,
                    ...serviceLocations,
                    ...templateLocations,
                    ...organizationLocations,
                    ...scheduleLocations,
                    ...priceLocations,
                    ...planLocations,
                    ...notificationLocations,
                    ...labLocations,
                    ...dashboardLocations,
                    ...profileLocations,
                    ...billingLocations,
                    ...uiLabLocations,
                    ...configurationLocations,
                    ...attachmentLocations,
                    ...financeLocations,
                    ...protestLocations,
                    ...promptsLocations,
                    ...clinicsLocations,
                    ...drugDemoLocations,
                    ...walkInLocations,
                    ...dataIsolationLocations,
                ].map(location => (
                    <Route
                        path={location.url}
                        key={location.url}
                        element={React.createElement(RouteContainer, location)}
                    />
                ))}
                <Route
                    path={USER_NOT_FOUND_ROUTE.$path()}
                    element={<UserNotFound />}
                />
                <Route
                    path="/billing-machine/*"
                    element={React.createElement(RouteContainer, {
                        url: '/billing-machine/*',
                        Component: BillingMachineApp,
                    })}
                />
                <Route
                    path={'*'}
                    element={<NotFound />}
                />
            </Routes>
        </ErrorBoundary>
    );
}
